import _objectSpread from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { isObject, isScrollBehaviorSupported, modifyPrototypes, nonFinite } from "./common.js";
import { elementScroll } from "./Element.scroll.js";
export var elementScrollBy = function elementScrollBy(element, options) {
  var left = nonFinite(options.left || 0) + element.scrollLeft;
  var top = nonFinite(options.top || 0) + element.scrollTop;
  return elementScroll(element, _objectSpread({}, options, {
    left: left,
    top: top
  }));
};
export var elementScrollByPolyfill = function elementScrollByPolyfill(animationOptions) {
  if (isScrollBehaviorSupported()) {
    return;
  }

  modifyPrototypes(function (prototype) {
    return prototype.scrollBy = function scrollBy() {
      if (arguments.length === 1) {
        var scrollByOptions = arguments[0];

        if (!isObject(scrollByOptions)) {
          throw new TypeError("Failed to execute 'scrollBy' on 'Element': parameter 1 ('options') is not an object.");
        }

        return elementScrollBy(this, _objectSpread({}, scrollByOptions, animationOptions));
      }

      var left = Number(arguments[0]);
      var top = Number(arguments[1]);
      return elementScrollBy(this, {
        left: left,
        top: top
      });
    };
  });
};